import { render, staticRenderFns } from "./CallParkingWallboard.vue?vue&type=template&id=2a83dc1e&scoped=true&"
import script from "./CallParkingWallboard.vue?vue&type=script&lang=js&"
export * from "./CallParkingWallboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83dc1e",
  null
  
)

export default component.exports